import React, { useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams, GridSortModel } from '@mui/x-data-grid';
import { useGetTransactionsQuery } from '../../state/api';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import DataGridCustomToolbar from '../../components/DataGridCustomToolbar';

// Typ pro jednu transakci (mělo by odpovídat backendu)
interface Transaction {
  _id: string; // MongoDB ID
  userId: string;
  cost: string; // v DB je uložen jako String
  products: Object; // pole ObjectId (každý odkazuje na něco jiného)
  createdAt: string;
  updatedAt: string;
}

const Transactions: React.FC = () => {
  const theme = useTheme();

  // values to be sent to the backend
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(20);
  const [sort, setSort] = useState<GridSortModel>([]);
  const [search, setSearch] = useState<string>('');
  const [searchInput, setSearchInput] = useState<string>('');

  const { data, isLoading } = useGetTransactionsQuery({
    page,
    pageSize,
    sort: JSON.stringify(sort[0]),
    search,
  });

  const columns: GridColDef<Transaction>[] = [
    {
      field: '_id',
      headerName: 'ID',
      flex: 1,
    },
    {
      field: 'userId',
      headerName: 'User ID',
      flex: 1,
    },
    {
      field: 'createdAt',
      headerName: 'CreatedAt',
      flex: 1,
    },
    {
      field: 'products',
      headerName: '# of Products',
      flex: 0.5,
      sortable: false,
      renderCell: (params: GridRenderCellParams<Transaction['products']>) =>
        params.value?.length ?? 0,
    },
    {
      field: 'cost',
      headerName: 'Cost',
      flex: 1,
      renderCell: (params) => `$${Number(params.value).toFixed(2)}`,
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <DashboardHeader title="TRANSACTIONS" subtitle="Entire list of transactions" />
      <Box
        height="80vh"
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: 'none',
          },
          '& .MuiDataGrid-virtualScroller': {
            backgroundColor: theme.palette.primary.light,
          },
          '& .MuiDataGrid-footerContainer': {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: 'none',
          },
          '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <DataGrid
          loading={isLoading || !data}
          getRowId={(row: Transaction) => row._id}
          rows={(data?.transactions as Transaction[]) || []}
          columns={columns}
          rowCount={(data && data.total) || 0}
          pageSizeOptions={[20, 50, 100]}
          pagination
          paginationMode="server"
          sortingMode="server"
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={(model) => {
            setPage(model.page);
            setPageSize(model.pageSize);
          }}
          onSortModelChange={(newSortModel) => setSort(newSortModel)}
          slots={{ toolbar: DataGridCustomToolbar } as any} //nefachá vyhledávání
          slotProps={{
            toolbar: {
              searchInput,
              setSearchInput,
              setSearch,
            } as any,
          }}
        />
      </Box>
    </Box>
  );
};

export default Transactions;
